export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-sharing-knowledge-c558748ade586728536d38178ba7a1c3.jpg";